import { h, Component } from 'preact';
import SnackBar from 'q-mdc/elements/material-snackbar';

import styles from './index.scss';

export default class SnackBarV2 extends Component {
	constructor(props) {
		super(props);
		this.timeoutMethod = null;
	}

	handleClose = (e) => {
		const { onClose, active } = this.props;
		if (active && typeof onClose === 'function') {
			onClose(e);
		}
	}

	render() {
		const { active, timeout } = this.props;

		if (this.timeoutMethod) {
			clearTimeout(this.timeoutMethod);
		}
		this.timeoutMethod = setTimeout(this.handleClose, timeout);
    
		return (<SnackBar
			{...this.props}
			active={active}
		/>);
	}
}


// WEBPACK FOOTER //
// ../q-components/components/SnackBar/index.js